export const isActiveScheduledMessage = (item) => {
    const attrs = item?.attributes || {};
    if (attrs.status === "pending") {
        return true;
    }
    if (attrs.status === "sent" && attrs.scheduledPinRemovalAt && !attrs.pinRemovalCompleted) {
        return true;
    }
    return false;
};

export const getScheduledMessagePhase = (item) => {
    const attrs = item?.attributes || {};
    if (attrs.status === "pending") {
        return "pending";
    }
    if (attrs.status === "sent" && attrs.scheduledPinRemovalAt && !attrs.pinRemovalCompleted) {
        return "pin_removal";
    }
    return null;
};
